import { Box } from '@material-ui/core';
import { SInfiniteTable } from '@setvi/shared/components/s-table/infinite';
import { Customer } from 'Services/Mongo/Types';
import { Product, ProductColumn } from '@setvi/shared/interfaces';
import { SText } from '@setvi/shared/components';
import { Alert } from '@material-ui/lab';
import InfoIcon from '@material-ui/icons/Info';
import { useMemo } from 'react';
import { useWarehouseColumns } from './useWarehouseColumns';
import { Wrapper } from './styled';
import { ProductsEmptyState } from '../../components';

export interface WarehouseProps {
  product: Product;
  selectedCustomer?: Customer;
  configColumns: ProductColumn[];
}

export const Warehouse = ({
  configColumns = [],
  product,
  selectedCustomer
}: WarehouseProps) => {
  const { warehouseColumns } = useWarehouseColumns({
    selectedCustomer,
    configColumns,
    stockInfo: product?.stockInfo
  });

  const content = useMemo(() => {
    if (product?.dropship)
      return (
        <Box mt={3}>
          <Alert severity="info" icon={<InfoIcon />}>
            This item is Dropshipped. It will be directly shipped to the
            customer. Stock availability may not be available for dropshipped
            items.
          </Alert>
        </Box>
      );

    if (product?.inventory?.length === 0)
      return (
        <Box flex={1} display="flex">
          <ProductsEmptyState title="No Inventory Available" />
        </Box>
      );

    return (
      <Box flex={1} overflow="auto">
        <SInfiniteTable
          newDesign
          list={product.inventory}
          columns={warehouseColumns}
          keyGetter={i => i._id}
        />
      </Box>
    );
  }, [product?.dropship, product.inventory, warehouseColumns]);

  return (
    <Box
      height="100%"
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}>
      <Wrapper>
        <SText
          style={{
            marginTop: 12
          }}
          weight="semibold"
          title="Warehouse"
        />
        {/* <Box display="flex" alignItems="center" gridGap="12px">
          <LastUpdated>Last updated:23h ago</LastUpdated>
          <SRefreshButton
            variant="text"
            queries={[]}
            style={{ minHeight: 0, height: 25 }}
          />
        </Box> */}
      </Wrapper>
      {content}
    </Box>
  );
};
